/* Mobile bottom bar — Category bottom sheet open/close.
   External file (perf-kit strips inline <script> on the homepage). */
(function () {
  function closeAll() {
    var open = document.querySelectorAll('.mbb-sheet.is-open');
    for (var i = 0; i < open.length; i++) {
      open[i].classList.remove('is-open');
      open[i].setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('mbb-sheet-lock');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-mbb-cat-open]');
    if (opener) {
      var sheet = document.getElementById(opener.getAttribute('data-mbb-cat-open'));
      if (sheet) {
        e.preventDefault();
        sheet.classList.add('is-open');
        sheet.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mbb-sheet-lock');
      }
      return;
    }
    if (e.target.closest && e.target.closest('[data-mbb-sheet-close]')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeAll();
  });

  // Swipe down on the panel to dismiss.
  var startY = null;
  document.addEventListener('touchstart', function (e) {
    var panel = e.target.closest && e.target.closest('.mbb-sheet__panel');
    startY = panel ? e.touches[0].clientY : null;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (startY === null) return;
    if (e.touches[0].clientY - startY > 70) { closeAll(); startY = null; }
  }, { passive: true });
})();
